import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReviewCard } from '../review-card';
import * as Styled from './reviews.style';

const reviews = Array.from({ length: 9 }, (_, index) => ({
  quoteKey: `forms.onboarding.premium.reviews.${index + 1}.quote`,
  authorKey: `forms.onboarding.premium.reviews.${index + 1}.author`,
}));

export const Reviews: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.ReviewsSection>
      <Styled.RatingBadge>
        <Typography variant="body2" component="span">
          {t('forms.onboarding.premium.rating-badge')}
        </Typography>
      </Styled.RatingBadge>

      <Styled.ReviewGrid>
        {reviews.map(({ quoteKey, authorKey }) => (
          <ReviewCard
            key={quoteKey}
            quoteKey={quoteKey}
            authorKey={authorKey}
          />
        ))}
      </Styled.ReviewGrid>
    </Styled.ReviewsSection>
  );
};
